import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (navigator.serviceWorker) {
      if (/(Turbo|Hotwire) Native/.test(navigator.userAgent)) {
        navigator.serviceWorker.getRegistrations().then(registrations => {
          registrations.forEach(registration => registration.unregister())
        })
        return
      }

      if (navigator.serviceWorker.controller) {
        // If the service worker is already running, skip to state change
        this.stateChange();
      } else {
        // Register the service worker, and wait for it to become active
        navigator.serviceWorker.register('/service-worker.js', { scope: "./" }).then(registration => {
          var serviceWorker;
          if (registration.installing) {
            serviceWorker = registration.installing;
          } else if (registration.waiting) {
            serviceWorker = registration.waiting;
          } else if (registration.active) {
            serviceWorker = registration.active;
          }
        }).catch(registrationError => {
          console.log('Service worker registration failed: ', registrationError);
        });
        navigator.serviceWorker.addEventListener(
          "controllerchange",
          this.controllerChange.bind(this)
        );
      }
    }
  }
 
  controllerChange(event) {
    const controller = navigator.serviceWorker.controller
    if (!controller) return

    controller.addEventListener("statechange", this.stateChange.bind(this));
  }
 
  stateChange() {
    // perform any visual manipulations here
  }
}
